import { create } from 'zustand';

interface FormLogRulesStore {
  logRules: Array<string>;
  addLogRule: (message: string) => void;
  clearLogRules: () => void;
}

export const useFormLogRulesStore = create<FormLogRulesStore>()((set) => ({
  logRules: [],
  addLogRule: (message) => set((state) => ({ logRules: [...state.logRules, message] })),
  clearLogRules: () => set({ logRules: [] })
}));
